import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

// pkg/dist-src/auth.js
function auth(_x) {
  return _auth.apply(this, arguments);
} // pkg/dist-src/is-rate-limit-error.js


function _auth() {
  _auth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reason) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", {
              type: "unauthenticated",
              reason: reason
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _auth.apply(this, arguments);
}

import { RequestError } from "@octokit/request-error";

function isRateLimitError(error) {
  if (error.status !== 403) {
    return false;
  }

  if (!error.response) {
    return false;
  }

  return error.response.headers["x-ratelimit-remaining"] === "0";
} // pkg/dist-src/is-abuse-limit-error.js


import { RequestError as RequestError2 } from "@octokit/request-error";
var REGEX_ABUSE_LIMIT_MESSAGE = /\babuse\b/i;

function isAbuseLimitError(error) {
  if (error.status !== 403) {
    return false;
  }

  return REGEX_ABUSE_LIMIT_MESSAGE.test(error.message);
} // pkg/dist-src/hook.js


function hook(_x2, _x3, _x4, _x5) {
  return _hook.apply(this, arguments);
} // pkg/dist-src/index.js


function _hook() {
  _hook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(reason, request, route, parameters) {
    var endpoint;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpoint = request.endpoint.merge(route, parameters);
            return _context2.abrupt("return", request(endpoint).catch(function (error) {
              if (error.status === 404) {
                error.message = "Not found. May be due to lack of authentication. Reason: ".concat(reason);
                throw error;
              }

              if (isRateLimitError(error)) {
                error.message = "API rate limit exceeded. This maybe caused by the lack of authentication. Reason: ".concat(reason);
                throw error;
              }

              if (isAbuseLimitError(error)) {
                error.message = "You have triggered an abuse detection mechanism. This maybe caused by the lack of authentication. Reason: ".concat(reason);
                throw error;
              }

              if (error.status === 401) {
                error.message = "Unauthorized. \"".concat(endpoint.method, " ").concat(endpoint.url, "\" failed most likely due to lack of authentication. Reason: ").concat(reason);
                throw error;
              }

              if (error.status >= 400 && error.status < 500) {
                error.message = error.message.replace(/\.?$/, ". May be caused by lack of authentication (".concat(reason, ")."));
              }

              throw error;
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _hook.apply(this, arguments);
}

var createUnauthenticatedAuth = function createUnauthenticatedAuth2(options) {
  if (!options || !options.reason) {
    throw new Error("[@octokit/auth-unauthenticated] No reason passed to createUnauthenticatedAuth");
  }

  return Object.assign(auth.bind(null, options.reason), {
    hook: hook.bind(null, options.reason)
  });
};

export { createUnauthenticatedAuth };